import accountsMetaReducer from './accountsMetaReducer';

export default accountsMetaReducer;
